<template>
  <form @submit.prevent="submit">
    <slot />
  </form>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    submit: {
      type: Function,
      required: true,
    },
  },
};
</script>
